import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import API_BASE_URL from '../config/api';

const StreamerPostingStatusPage = () => {
  const { submissionId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/streamer/submissions/${submissionId}/status`);
        if (!response.ok) throw new Error('Failed to fetch status');
        const result = await response.json();
        setStatus(result.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
  }, [submissionId]);

  const getStatusMessage = () => {
    if (!status) return { severity: 'info', text: 'Loading...' };
    const paid = ['paid', 'promo', 'completed'].includes(status.payment_status);
    if (!paid) return { severity: 'warn', text: 'Payment pending...' };

    switch (status.posting_status) {
      case 'completed':
        return { severity: 'success', text: 'Your post is live on Instagram!' };
      case 'failed':
        return { severity: 'error', text: status.posting_error || 'Posting failed. Contact support.' };
      case 'posting':
        return { severity: 'info', text: 'Posting to Instagram now...' };
      default:
        return { severity: 'success', text: 'Payment confirmed! Your post is queued.' };
    }
  };

  const msg = getStatusMessage();

  if (loading) {
    return (
      <div className="posting-status-page">
        <ProgressSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="posting-status-page container">
        <Message severity="error" text={error} />
      </div>
    );
  }

  return (
    <div className="posting-status-page">
      <div className="container">
        <Card title="UniStreaming — Post Status">
          <Message severity={msg.severity} text={msg.text} className="status-message" />
          {status?.name && <p><strong>Name:</strong> {status.name}</p>}
          {status?.instagram_post_id && (
            <p><strong>Instagram Post ID:</strong> {status.instagram_post_id}</p>
          )}
          <Button label="Back to Home" icon="pi pi-home" onClick={() => navigate('/')} className="mt-4" />
        </Card>
      </div>
    </div>
  );
};

export default StreamerPostingStatusPage;
